import { getPostHogClient } from "./client";

export type IdentifyableUser = {
  id: string;
};

/** Blocks identify() until the session is actually unauthenticated after logout. */
let suppressIdentifyUntilSignedOut = false;

export function isRealUserId(userId: string): boolean {
  const value = userId.trim();
  if (!value) return false;
  if (value.includes("@")) return false;
  if (value === "guest" || value === "anonymous" || value === "user") {
    return false;
  }
  return true;
}

export function isAnalyticsIdentifySuppressed(): boolean {
  return suppressIdentifyUntilSignedOut;
}

export function allowAnalyticsIdentify(): void {
  suppressIdentifyUntilSignedOut = false;
}

/**
 * Identify only after a real login. Never use email as distinct_id.
 * Never call for anonymous or guest users.
 */
export function identifyLoggedInUser(
  user: IdentifyableUser,
  person?: { profile_id?: string; participant_type?: string }
): void {
  if (suppressIdentifyUntilSignedOut) return;
  if (!isRealUserId(user.id)) return;
  const client = getPostHogClient();
  if (!client) return;

  client.identify(user.id, {
    user_id: user.id,
    ...(person?.profile_id ? { profile_id: person.profile_id } : {}),
    ...(person?.participant_type
      ? { participant_type: person.participant_type }
      : {}),
  });
}

export function resetAnalytics(): void {
  suppressIdentifyUntilSignedOut = true;
  const client = getPostHogClient();
  if (!client) return;
  client.reset();
}

export function hasIdentifiedAnalyticsUser(): boolean {
  if (suppressIdentifyUntilSignedOut) return false;
  const client = getPostHogClient();
  if (!client) return false;
  const userId = client.get_property("user_id");
  return typeof userId === "string" && isRealUserId(userId);
}
